import React, { ReactNode } from 'react';
import { Card, Grid } from 'ui-toolkit/components';
import { GrayCard } from './shared/GrayCard';

export const ViewerTemplate: React.FC<{
  viewerName: string | ReactNode;
  templateColumns?: string;
  children?: React.ReactNode;
}> = ({ viewerName, templateColumns, children }) => (
  <GrayCard isCollapsible title={viewerName}>
    <Grid templateColumns={templateColumns || '1fr 11fr'}>
      <div />
      <Card>{children}</Card>
    </Grid>
  </GrayCard>
);
